var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCitesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    xmlSpace: "preserve",
    width: 764.78668,
    height: 437.61334,
    viewBox: "0 0 764.78668 437.61334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,437.61333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2449.81,49.6992 h 711.57 V 2157.5 H 2449.81 V 49.6992",
    style: {
      fill: "#183857",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2611.89,2237.46 202.83,636.34 h 1524.54 l 209.51,-639.68 H 3953.66 V 651.629 H 3227.04 V 2237.46 h -615.15",
    style: {
      fill: "#183857",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4019.4,604.809 H 3732.99 V 49.8281 h 1145.63 l 138.2,552.7499 H 4475.21 V 867.82 h 218.42 l 131.51,534.93 h -323.19 v 247.4 h 583.96 l -238.49,682.03 h -267.46 l 51.26,-147.11 H 4019.4 V 604.809",
    style: {
      fill: "#183857",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4702.55,2389.02 c 0,0 124.8,402.32 554.98,344.36 154.35,-13.98 249.64,-78.01 249.64,-78.01 l 205.05,-563.91 c 0,0 -207.28,178.32 -329.87,-53.49 0,0 -42.35,-62.4 33.43,-209.51 75.78,-147.11 287.52,-621.85 287.52,-621.85 0,0 49.03,-120.35 26.75,-238.481 C 5707.76,850 5640.89,551.328 5304.34,504.531 5085.91,480 5059.17,497.84 5059.17,497.84 l 42.34,160.48 h -383.36 l 92.59,365.52 h 141.44 c 0,0 100.3,28.99 64.64,173.86 l -173.85,394.5 h 320.95 l -276.38,796.82 h -184.99",
    style: {
      fill: "#183857",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1909.36,98.0508 c 0,40.8282 36.23,74.0512 80.76,74.0512 44.53,0 80.76,-33.223 80.76,-74.0512 0,-40.832 -36.23,-74.0391 -80.76,-74.0391 -44.53,0 -80.76,33.2071 -80.76,74.0391 z m -24,0 C 1885.36,43.9883 1932.36,0 1990.12,0 c 57.77,0 104.76,43.9883 104.76,98.0508 0,54.0582 -46.99,98.0582 -104.76,98.0582 -57.76,0 -104.76,-44 -104.76,-98.0582",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2014.54,120.84 c -1.4,2.148 -3.16,4.058 -5.28,5.691 -2.11,1.637 -4.5,2.91 -7.17,3.828 -2.67,0.903 -5.46,1.36 -8.37,1.36 -5.34,0 -9.87,-0.981 -13.59,-2.957 -3.72,-1.973 -6.74,-4.614 -9.06,-7.934 -2.31,-3.328 -4,-7.09 -5.05,-11.328 -1.06,-4.23 -1.59,-8.609 -1.59,-13.1289 0,-4.332 0.53,-8.543 1.59,-12.6211 1.05,-4.1016 2.74,-7.7812 5.05,-11.0508 2.32,-3.2695 5.34,-5.8906 9.06,-7.8594 3.72,-1.9687 8.25,-2.9609 13.59,-2.9609 7.24,0 12.9,2.1094 16.97,6.3516 4.08,4.2304 6.57,9.8008 7.47,16.7304 h 22.95 c -0.61,-6.4492 -2.16,-12.2617 -4.68,-17.4609 -2.51,-5.1914 -5.83,-9.6094 -9.97,-13.2695 -4.12,-3.6602 -8.95,-6.4492 -14.48,-8.3711 -5.53,-1.918 -11.62,-2.8906 -18.26,-2.8906 -8.26,0 -15.68,1.371 -22.27,4.121 -6.6,2.7383 -12.16,6.5196 -16.7,11.3204 -4.54,4.8203 -8.02,10.4687 -10.43,16.9687 -2.43,6.4922 -3.64,13.4922 -3.64,20.9922 0,7.6989 1.21,14.8479 3.64,21.4379 2.41,6.589 5.89,12.332 10.43,17.242 4.54,4.918 10.1,8.758 16.7,11.551 6.59,2.789 14.01,4.187 22.27,4.187 5.93,0 11.54,-0.82 16.83,-2.461 5.28,-1.637 10.01,-4.019 14.18,-7.148 4.18,-3.129 7.62,-7 10.34,-11.61 2.72,-4.621 4.43,-9.922 5.13,-15.871 h -22.94 c -0.4,2.59 -1.31,4.981 -2.72,7.141",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2399.22,1136.06 c -265,-232.501 -704.84,-364.162 -704.84,-364.162 -295,-92.5 -567.5,-37.5 -567.5,-37.5 -367.505,70 -595.005,215 -772.505,345.002 -177.5,130 -323.2852,330.62 -323.2852,330.62 C 231.09,1217.52 454.375,1126.9 454.375,1126.9 849.457,935.578 1104.38,929.398 1496.88,1029.4 c 427.07,113.06 873.59,546.13 902.34,573.33 v -466.67",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2399.22,1917.62 c 0,0 -224.19,-225.12 -484.97,-236.26 -260.77,-11.14 -474.75,189.46 -505.95,381.14 -31.2,191.67 26.75,381.13 234.03,505.95 0,0 247.41,169.39 581.74,4.46 l 49.03,-24.52 182.64,583.35 c 0,0 -683.16,359.03 -1275.88,-32.49 C 860.715,2893.4 656.875,2533 656.875,2119.4 c 0,-119.13 17.117,-219.94 48.953,-305.23 52.793,-175.31 148.879,-324.58 265.805,-430.59 0,0 226.797,-236.74 562.027,-327.97 -13.54,-4.18 -27.09,-8.12 -40.62,-11.71 -361.9,-92.209 -620.954,-102.611 -1032.126,96.5 -2.476,1.28 -264.844,117.15 -460.914,305.87 0,0 168.477,-249.31 345.512,-378.97 191.047,-139.921 417.593,-278.878 778.558,-347.64 2.6,-0.519 279.53,-54.66 574.79,37.918 3.79,1.063 435.85,129.762 700.36,361.822 v 35 C 2139.92,926.891 1694.5,787.512 1690.33,786.34 1402.25,696.02 1132.53,748.559 1129.84,749.109 774.566,816.77 551.445,953.66 363.238,1091.5 c -86.656,63.47 -159.144,139.67 -232.609,219.48 168.32,-127.24 314.652,-196.27 316.851,-197.4 419.868,-203.33 684.02,-192.74 1053.1,-98.71 405.47,107.33 819.86,485.08 898.64,559.72 v 1.74 c 0.37,0.34 0,0.57 0,0.57 v 340.72",
    style: {
      fill: "#183857",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitesLogo);
export default __webpack_public_path__ + "static/media/cites-logo.130c047fe473acf2a5007fb425821259.svg";
export { ForwardRef as ReactComponent };